import React, { useEffect, useState } from 'react';
import RfiForm from '../components/form/RfiForm';
import { simpleAuthGET } from '../api';
import { apiUrl } from '../api/apiConfig';
import { useParams } from 'react-router-dom';

// For debugging pdf
// import { PDFViewer } from '@react-pdf/renderer';
// import PdfDocument from '../components/pdfDocument';

export default function LookupRFI () {
    const [data, setData] = useState(null);
    let { id } = useParams(); // gets id from url

    // Fetch form data.
    useEffect(() => {
        const url = `${apiUrl}/api/rfi/${id}`;
        try {
            simpleAuthGET(url)
                .then(response => {
                    setData(response);
                });
        }
        catch (e) {
            //TODO: toast error needed here
            console.error('error', e);
        }
    }, [id]);

    return (
        <div style={{width: '100%'}}>
            {data ?
                <RfiForm isInternal={true} prefillFormData={data} formId={id} /> 
                // For debugging pdf
                // <PDFViewer width={1000} height={1400}>
                //     <PdfDocument data={data} files={[]} isInternal={true}/>
                // </PDFViewer>
                :
                <h3 style={{paddingLeft: '20px'}}>Loading...</h3>
            }
        </div>
    );
}